import { Modal, Typography } from "antd";
import React, { useState } from "react";

const { Text, Title } = Typography;

const Terms: React.FC = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Text
        onClick={e => {
          e.preventDefault();
          setVisible(true);
        }}
        style={{ textDecoration: "underline", padding: 0 }}
      >
        vilkårene for booking
      </Text>
      <Modal
        title={<Title level={5}>Vilkår for booking av bedriftspresentasjon</Title>}
        centered
        open={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        footer={null}
        bodyStyle={{ width: "auto", maxHeight: "calc(100vh - 200px)" }}
      >
        <ul>
          {/* TODO update these to match current rules  */}
          <li>
            Avbestilling inntil en måned før presentasjonen (30+ dager): Gratis. <br />
            <br />{" "}
          </li>
          <li>
            Avbestilling mindre enn én måned før presentasjonen (0-30 dager): Gebyr på 100%.
            <br />
            <br />{" "}
          </li>
          <li>Minst halvparten av plassene på arrangementet må være satt av til Indøk-studenter. </li>
        </ul>
      </Modal>
    </>
  );
};

export default Terms;
